import {adminixService} from '../index'

class Automation {
    getAutomations = () => adminixService.get('automations')
    getEvents = () => adminixService.get('events')
    createAutomation = data => adminixService.post('automation', data)
    updateAutomation = (id, data) => adminixService.put(`automation/${id}`, data)
    deleteAutomation = id => adminixService.delete(`automation/${id}`)
    getToken = id => adminixService.post(`automation/${id}/token`)
    getWorkflowId = id => adminixService.get(`automation/${id}`)
}

export default new Automation()
